module.exports = __webpack_public_path__ + "assets/Retina-Book.e495323dd7769a917b7287374e22ef41.woff";